import { motion } from "framer-motion";
import { EASE } from "@/lib/scroll";

export default function VetTrust() {
  return (
    <section id="veterinar" className="relative py-24 lg:py-36">
      <div className="mx-auto max-w-5xl px-6 text-center lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="mb-6 flex items-center justify-center gap-4">
            <span className="h-px w-12 bg-gold/70" />
            <p className="font-mono text-[10px] uppercase tracking-[0.38em] text-gold sm:text-[11px]">
              Încredere veterinară
            </p>
            <span className="h-px w-12 bg-gold/70" />
          </div>

          <span className="font-serif text-7xl leading-none text-gold/30" aria-hidden="true">
            „
          </span>
          <h2 className="mx-auto max-w-3xl font-serif text-3xl font-light leading-[1.15] tracking-tight text-cream sm:text-4xl lg:text-5xl">
            Testat și apreciat de <em className="text-gold-gradient">medici veterinari</em>.
          </h2>
          <p className="mx-auto mt-10 max-w-2xl text-base italic leading-relaxed text-stone lg:text-lg">
            „Formula NOSA întrunește echilibrul ideal de hidratare naturală, aport proteic
            curat și absență totală a carbohidraților inutili. Este recomandarea ideală pentru
            pisici cu sensibilități digestive sau proprietari care refuză compromisul.”
          </p>
        </motion.div>

        <div className="mt-12 flex items-center justify-center gap-4">
          <span className="h-px w-16 bg-gold/40" />
          <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
          <span className="h-px w-16 bg-gold/40" />
        </div>
      </div>
    </section>
  );
}
